import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import GoogleLogin from "../../components/LoginProvider/GoogleLogin";
import { AuthContext } from "../../contexts/AuthProvider";
import useToken from "../../hooks/useToken";
import toast from "react-hot-toast";

const Register = () => {
  // State
  const [createdUserEmail, setCreatedUserEmail] = useState("");

  const navigate = useNavigate();
  const { createUser, updateUserProfile } = useContext(AuthContext);
  // React Hooks Form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // If token is generated redirect to home route
  const [token] = useToken(createdUserEmail);

  if (token) {
    navigate("/");
  }

  const onSubmit = ({ name, email, password }) => {
    console.log(name, email, password);
    // Create user using firebase
    createUser(email, password)
      .then((result) => {
        const user = result.user;
        if (user.email) {
          toast.success("Login Success");
          // Update Profile after successful login
          updateUserProfile({ displayName: name })
            .then((data) => {
              toast.success("Profile Updated");
              saveUser(name, email, password);
            })
            .catch((error) => {
              // An error occurred
              // ...
              console.log(error);
            });
        }
      })
      .catch((err) => console.log(err));
  };

  const saveUser = (name, email, password) => {
    const user = { name, email, password, role: "user" };

    fetch("https://doctors-portal-server-azure.vercel.app/users", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(user),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.acknowledged) {
          // Setting email for useToken
          setCreatedUserEmail(email);
        }
      });
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="min-w-[380px] p-7 shadow">
        <h2 className="text-xl font-medium my-5">REGISTER</h2>
        <form onSubmit={handleSubmit(onSubmit)} className="grid gap-4">
          {/* User Name field */}
          <div className="form-control w-full ">
            <input
              type="text"
              placeholder="Name"
              className="input input-bordered w-full max-w-xs"
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && (
              <p role="alert" className="mt-2 text-red-800 text-sm ml-1">
                {errors.name?.message}
              </p>
            )}
          </div>

          {/* Email field */}
          <div className="form-control w-full ">
            <input
              type="email"
              placeholder="Email"
              className="input input-bordered w-full max-w-xs"
              {...register("email", { required: "Email is required" })}
            />
            {errors.email && (
              <p role="alert" className="mt-2 text-red-800 text-sm ml-1">
                {errors.email?.message}
              </p>
            )}
          </div>

          {/* Password field */}
          <div className="form-control w-full ">
            <input
              type="password"
              placeholder="Password"
              className="input input-bordered w-full max-w-xs"
              {...register("password", {
                required: "Password is required",
                pattern: {
                  value:
                    /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{6,}$/,
                  message:
                    "password contain 6 letters with at least a symbol, upper and lower case letters and a number",
                },
              })}
            />
            {errors.password && (
              <p
                role="alert"
                className="mt-2 text-red-800 text-sm ml-1 max-w-[300px]"
              >
                {errors.password?.message}
              </p>
            )}
          </div>
          <input type="submit" value="Register" className="btn w-full my-2" />
        </form>
        <p className="text-sm my-2">
          Already have an account ?{" "}
          <Link to="/login" className="text-secondary font-medium ">
            Please Login
          </Link>
        </p>
        <div className="divider">OR</div>
        <GoogleLogin />
      </div>
    </div>
  );
};

export default Register;
